import { useState, useEffect } from "react";
import { Typography, Box } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import Loading from "../ui/Loading";
import OpsHealthCallsModal from "./OpsHealthCallsModal";

const AllIncompleteCallsCard = ({
  filters,
  allIncompleteCount,
  getAllIncompleteCallsCount,
  allIncompleteCalls,
  getAllIncompleteCalls,
  exportAllIncompleteCalls,
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const hasCount = Number.isFinite(allIncompleteCount?.data);
  const countValue = hasCount ? Number(allIncompleteCount.data) : 0;

  useEffect(() => {
    getAllIncompleteCallsCount(filters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  const handleCardClick = () => setModalOpen(true);
  const handleModalClose = () => setModalOpen(false);

  if (allIncompleteCount.isLoading && !hasCount) return <Loading />;
  if (allIncompleteCount.error && !hasCount)
    return <Typography color="error">{allIncompleteCount.error}</Typography>;

  return (
    <>
      <Box
        onClick={handleCardClick}
        sx={{
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
          p: 2,
          borderRadius: 1,
          backgroundColor: "#fff3e0",
          border: "1px solid #ffa726",
          transition: "all 0.2s",
          mt: 2,
          mb: 1,
          "&:hover": { backgroundColor: "#ffe0b2", boxShadow: 2 },
        }}
      >
        <ErrorOutlineIcon sx={{ color: "#ffa726", fontSize: 40, mr: 2 }} />
        <Box>
          <Typography
            variant="h4"
            sx={{ color: "#ffa726", fontWeight: "bold" }}
          >
            {countValue}
          </Typography>
          <Typography
            variant="caption"
            color="text.secondary"
          >
            Incomplete Calls (All Dates)
          </Typography>
        </Box>
      </Box>
      <OpsHealthCallsModal
        open={modalOpen}
        onClose={handleModalClose}
        metricType="allIncomplete"
        filters={filters}
        allIncompleteCalls={allIncompleteCalls}
        getAllIncompleteCalls={getAllIncompleteCalls}
        exportAllIncompleteCalls={exportAllIncompleteCalls}
      />
    </>
  );
};

export default AllIncompleteCallsCard;
